import React, { useState } from 'react';
import { Stage, Layer, Rect, Line, Text, Group, Circle } from 'react-konva';
import {globalinchtopointfactor, globalnormalopacity, coverHeight } from "./AuxiliaryFunctions";

var inchtopointfactor = globalinchtopointfactor;
const normalopacity = globalnormalopacity;

const kicktoeheight = 24;
const epsilon = 0.05;

const tooltipState = {
  text: '',
  visible: false,
  x: 0,
  y: 0
};

const FillerEndPanels = (props) => {

  let adjustedHeight;

  if (props.rect.cabinettype === "base_cabinet") {
    adjustedHeight = props.rect.height - kicktoeheight;
  }
  else if (props.rect.cabinettype === "wall_cabinet") {
    adjustedHeight = props.rect.height;
  }
  else {
    adjustedHeight = props.rect.height;
  }
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
      <CommonRect rect={rect} />   
      {rect.width >= 12 &&
        <Text
          text={parseFloat(rect.width/inchtopointfactor) + "in x " + parseFloat(rect.height/inchtopointfactor) + "in"}
          rotation={-90}
          offset={{x:rect.height/2,y:-rect.width/6}}
        />      
      }
      <ToolTipHoverComponent rect={rect} />
    </>
  )
};

const BaseWallTallDoorPanel = (props) => {
  let adjustedHeight;

  if ((props.rect.cabinettype === "base_cabinet")) {
    adjustedHeight = props.rect.height - kicktoeheight;
  }
  else if (props.rect.cabinettype === "wall_cabinet") {
    adjustedHeight = props.rect.height;
  }
  else {
    adjustedHeight = props.rect.height;
  }
  let rect = {...props.rect, adjustedHeight: adjustedHeight};  
  //delete rect.panelSide; // to avoid passing it down to CommonRect and causing issues

  return (
    <>
    <CommonRect rect={rect} />
    <ToolTipHoverComponent rect={rect} />
    </>
  );
}

const PanelForWallF = (props) => {
  let rect = {...props.rect};  
  return (
    <>
    <CommonRect rect={rect} />
    </>
  );  
}

const NoCornerPlaceholder = (props) => {
  const rect = props.rect;  
  if (rect.forTallCabinetId) {
    rect.stroke = "lightgray";
  }else {
    rect.stroke = "black";
  }
  return (
    <>
    {/**change fill to lightgray to ensure it is not visible */}
    <CommonRect rect={{...rect, fill:"lightgray", dash:[10, 5]}} /> 
    <ToolTipHoverComponent rect={rect} />
    </>  
  );  
};


const CornerBaseCabinets = (props) => {
  const rect = props.rect;
  const cornerbasewidth = 24*inchtopointfactor;
  return (
    <>
    <CommonRect rect={rect} />

    <Line
      points={[cornerbasewidth, rect.height, cornerbasewidth, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
    />                    
    </>  
  )
}

const ForAllCabinets = (props) => {
  const rect = props.rect;
  return (
    <>
    <CommonRect rect={rect} />  

    <Line
      points={[0, 0, rect.width+0, -rect.height/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.height)/2}
    />                    
    <Line
      points={[0, 0, rect.width+0, rect.height/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.height)/2}/>  
    </>  
  )
};

/// BEGIN BASE CABINETS /////////////////////////////////////////////////////////////////////////////////////////////////////////////

const Bx1SHx1DRxS = (props) => { // W from 12" to 24"
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};    
  return (
    <>
    <CommonRect rect={rect} 
    />
    <OneShelf rect={rect} />  
    {/**<ToolTipHoverComponent rect={rect} />  */}
    </>  
  );
};

const Bx2ROx1DRxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />
    <TwoRollOuts rect={rect} />      
    {/*<ToolTipHoverComponent rect={rect} />                      */}
    </>  
  );
};

const BxPOxWd1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />
    {/*the pull out created with a rect*/}
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={rect.width/8}
      y={15}
      width={rect.width*0.75}
      height={8}
      cornerRadius={4}
    />        
    {/*<ToolTipHoverComponent rect={rect} />   */}
    </>  
  );
};

const Bx1DWRx1SHx1DRxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />
    {/*top drawer*/}
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={0}
      y={0}
      width={rect.width}
      height={25}
    />  
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={rect.width/8}
      y={15}
      width={rect.width*0.75}
      height={4}
      cornerRadius={2}
    />   
    <OneShelf rect={rect} />
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>  
  );
};

const Bx2DWrx1SHx2DR = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  
  return (
    <>
    <CommonRect rect={rect} />
    {/*top drawers*/}
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={5}
      y={5}
      width={rect.width/2-10}
      height={25}
    />   
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={rect.width/8}
      y={15}
      width={rect.width/4}
      height={4}
      cornerRadius={2}
    /> 

    <Rect 
      stroke="black"
      strokeWidth={1}
      x={rect.width/2+5}
      y={5}
      width={rect.width/2-10}
      height={25}
    /> 
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={5*rect.width/8}
      y={15}
      width={rect.width/4}
      height={4}
      cornerRadius={2}
    />  
    <OneShelf rect={rect} />    
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>  
  );
};

const BxSDwr = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  // this component depends on rect.height...
  //const rect = props.rect;
  const numDrawersFronts = rect.numDrawersFronts;
  const arrns = Array.from({ length: numDrawersFronts}, (v, k) => k);

  return (
    <>
    <CommonRect rect={rect} />    
    {arrns.map((arrn, i) => {
      return (
        <> 
        <Line 
          points={[5, i*rect.adjustedHeight/numDrawersFronts-rect.adjustedHeight/2, rect.width-5, i*rect.adjustedHeight/numDrawersFronts-rect.adjustedHeight/2]}
          stroke="black"
          strokeWidth={1}
          lineJoin="round"
          y={0+(rect.adjustedHeight)/2}    
        />        
        <Rect 
          stroke="black"
          strokeWidth={1}
          x={rect.width/4}
          y={i*rect.height/numDrawersFronts+0.5*(rect.adjustedHeight-10)/numDrawersFronts}
          width={rect.width/2}
          height={4}
          cornerRadius={2}
        /> 
        </>
      );
    })}  
    {/*<ToolTipHoverComponent rect={rect} />  */}
    </>
  );
}

const Bx1DWRx2ROx1DRxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />
    {/*top drawer*/}
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={0}
      y={0}
      width={rect.width}
      height={25}
    />   
    <TwoRollOuts rect={rect} />   
    {/*<ToolTipHoverComponent rect={rect} />          */}
    </>  
  );
};

const BxSINKx1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />
    {/* Faucet */}          
    <Rect
      fill={"silver"}
      cornerRadius={3}
      stroke="black"
      strokeWidth={1}
      x={rect.width/2-3}
      y={-45}
      width={6}
      height={47}
    />   
    <Rect
      fill={"silver"}
      stroke="black"
      strokeWidth={2}
      x={rect.width/2-3}
      y={-28}
      width={6}
      height={10}
    />

    <Rect
      fill={"silver"}
      stroke="black"
      strokeWidth={1}
      x={rect.width/2-20}
      y={-20}
      width={6}
      height={20}
    /> 
    <Rect
      fill={"hsl(0, 100%, 35%)"}
      stroke={"hsl(0, 100%, 35%)"}
      strokeWidth={1}
      x={rect.width/2-20-15}
      y={-20}
      width={25}
      height={5}
      cornerRadius={3}
    />       
    <Rect
      fill={"silver"}
      stroke="black"
      strokeWidth={1}
      x={rect.width/2+20-6}
      y={-20}
      width={6}
      height={20}
    /> 
    <Rect
      fill={"#0054b3"}
      stroke={"#0054b3"}
      strokeWidth={1}
      x={rect.width/2+20-10}
      y={-20}
      width={25}
      height={5}
      cornerRadius={3}
    />   
    <Rect
      fill={"silver"}
      stroke="black"
      strokeWidth={1}
      x={rect.width/2-30}
      y={-8}
      width={60}
      height={8}
    />              
    {/*top drawer*/}
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={0}
      y={0}
      width={rect.width}
      height={25}
    />     
    {/*<ToolTipHoverComponent rect={rect} /> */}
    </>  
  );
};

/// END BASE CABINETS //////////////////////////////////////////////////////////////////////////////////////////////////////

/// BEGIN UPPER CABINETS ///////////////////////////////////////////////////////////////////////////////////////////////////

const Wx2Shx1DRxS = (props) => {
  const rect = props.rect;
  return (
    <>
    <CommonRect rect={rect} />
    <TwoShelves rect={rect}/>
    <ToolTipHoverComponent rect={rect} />    
    </>  
  );
};

const Rx2DRxS = (props) => {

  let xcabinet = props.rect.x;
  let xleftpanel = props.rect.x;
  let xrightpanel = props.rect.x + props.rect.width;

  const leftPanelRect = {
    ...props.rect,
    width:12,
    height: 500,
    x: xleftpanel,
    side: "NA",
  }
  const rightPanelRect = {
    ...props.rect,
    width:12,
    height: 500,
    x: xrightpanel,
    side: "NA",
  }

  if (props.rect.panelSide === "L") {
    xcabinet = 12; // move cabinet to the right to accommodate left panel
  }
  else {
    xcabinet = 0;         
  }

  const rect = {
    ...props.rect,
    //x: xcabinet
  };

  return (
    <>
    <CommonRect rect={rect} />
    <ToolTipHoverComponent rect={rect} />        
    </>
  );
   


  /*
  return (
    <>
    {(rect.panelSide === "L") &&
      <BaseWallTallDoorPanel rect={leftPanelRect} />
    }    
    <CommonRect rect={rect} />
    {(rect.panelSide === "R") &&
      <BaseWallTallDoorPanel rect={rightPanelRect} />
    }
    <Text
      text={props.rect.panelSide + ", " + xcabinet}
    />

    <ToolTipHoverComponent rect={rect} />        
    </>  
  );
  */
};

const Wx2DRxS = (props) => {
  const rect = props.rect;
  return (
    <>
    <CommonRect rect={rect} />
    <Rect
      x={0}
      y={rect.height}
      fill={"black"}
      width={rect.width}
      height= {rect.height>130 ? 54 : 0.7*rect.height}
      stroke="black"
      strokeWidth={1}
      opacity={0.4}
    />        
    <Line
      opacity={0.5}
      points={[0, 1.5*rect.height, rect.width, 1.5*rect.height]}
      stroke="silver"
      strokeWidth={1}
      lineJoin="round"
    />
    <Rect
      x={rect.width/4}
      y={1.55*rect.height}
      fill={"silver"}
      width={rect.width/2}
      height= {rect.height>130 ? 2 : 6}
      stroke={"silver"}
      strokeWidth={1}
      opacity={1}      
    />   
    <Rect
      x={rect.width/8}
      y={1.71*rect.height}
      width={rect.width/4}
      height={2}
      fill="hsl(59, 99%, 50%)" 
      shadowColor="hsl(59, 99%, 50%)" // Use the fill color for a diffused glow effect
      shadowBlur={15}   // Adjust the blur radius
      shadowOffsetX={0}
      shadowOffsetY={0}
      perfectDrawEnabled={false} // May help with performance/rendering
      strokeWidth={1}  
    />       
    <Rect
      x={5*rect.width/8}
      y={1.71*rect.height}
      width={rect.width/4}
      height={2}
      fill="hsl(59, 99%, 50%)" 
      shadowColor="hsl(59, 99%, 50%)" // Use the fill color for a diffused glow effect
      shadowBlur={15}   // Adjust the blur radius
      shadowOffsetX={0}
      shadowOffsetY={0}
      perfectDrawEnabled={false} // May help with performance/rendering
      strokeWidth={1}  
    />       

    <ToolTipHoverComponent rect={rect} />    
    </>  
  );
};

const WxVx1Dr = (props) => {
  const rect = props.rect;
  return (
    <>
    <CommonRect rect={rect} />
    <Rect
      x={rect.width/4}
      y={rect.height/4}
      width={rect.width/2}
      height={5}
      cornerRadius={2} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />    

    <Rect
      x={0}
      y={rect.height}
      fill={"black"}
      width={rect.width}
      height= {rect.height>130 ? 54 : 0.7*rect.height}
      stroke="black"
      strokeWidth={1}
      opacity={0.4}
    />        
    <Line
      opacity={0.5}
      points={[0, 1.5*rect.height, rect.width, 1.5*rect.height]}
      stroke="silver"
      strokeWidth={1}
      lineJoin="round"
    />
    <Rect
      x={rect.width/4}
      y={1.55*rect.height}
      fill={"silver"}
      width={rect.width/2}
      height= {rect.height>130 ? 2 : 6}
      stroke={"silver"}
      strokeWidth={1}
      opacity={1}      
    />   
    <Rect
      x={rect.width/8}
      y={1.71*rect.height}
      width={rect.width/4}
      height={2}
      fill="hsl(59, 99%, 50%)" 
      shadowColor="hsl(59, 99%, 50%)" // Use the fill color for a diffused glow effect
      shadowBlur={15}   // Adjust the blur radius
      shadowOffsetX={0}
      shadowOffsetY={0}
      perfectDrawEnabled={false} // May help with performance/rendering
      strokeWidth={1}  
    />       
    <Rect
      x={5*rect.width/8}
      y={1.71*rect.height}
      width={rect.width/4}
      height={2}
      fill="hsl(59, 99%, 50%)" 
      shadowColor="hsl(59, 99%, 50%)" // Use the fill color for a diffused glow effect
      shadowBlur={15}   // Adjust the blur radius
      shadowOffsetX={0}
      shadowOffsetY={0}
      perfectDrawEnabled={false} // May help with performance/rendering
      strokeWidth={1}  
    />  

    <ToolTipHoverComponent rect={rect} />                
    </>  
  );  
};

const Rx1DrxS = (props) => {
  const rect = props.rect;
  return (
    <>
    <CommonRect rect={rect} />
    <Rect
      x={rect.width/4}
      y={2*rect.height/4}
      width={rect.width/2}
      height={5}
      cornerRadius={2} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />    
    <ToolTipHoverComponent rect={rect} />                
    </>  
  );  
};

const WxVx1SHx1Dr = (props) => {
  const rect = props.rect;
  return (
    <>
    <CommonRect rect={rect} />
    <Rect
      x={rect.width/4}
      y={rect.height-26}
      width={rect.width/2}
      height={5}
      cornerRadius={2} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />        
    <OneShelf rect={rect} />
    <ToolTipHoverComponent rect={rect} />
    </>  
  );  
};

/// END UPPER CABINETS /////////////////////////////////////////////////////////////////////////////////////////////////////

const Ox1FSx1DWx2Dr = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  
  return (
    <>
    <CommonRect rect={rect} />    
    <Line 
      points={[0, adjustedHeight/6, rect.width, adjustedHeight/6]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}   
      dash={[5, 5]} 
    /> 
    <Line 
      points={[0, adjustedHeight/6+5, rect.width, adjustedHeight/6+5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}   
      dash={[5, 5]} 
    />  
    <Line 
      points={[0, 2*adjustedHeight/6, rect.width, 2*adjustedHeight/6]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}   
    />       
    <Line 
      points={[0, 2*adjustedHeight/6+5, rect.width, 2*adjustedHeight/6+5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}   
    />     

    <Line
      points={[0, adjustedHeight/6, rect.width/2, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0}/>                    
    <Line
      points={[0, adjustedHeight/6, rect.width/2, 2*adjustedHeight/6+5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0}/>    
    <Line
      points={[rect.width/2, 0, rect.width, adjustedHeight/6]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0}/>                    
    <Line
      points={[rect.width/2, 2*adjustedHeight/6+5, rect.width, adjustedHeight/6]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0}/>     
    <Line
      points={[rect.width/2, 0, rect.width/2, adjustedHeight/3]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}/>        

    <ToolTipHoverComponent rect={rect} />
    </>  
  );  
};

const Tx4SHx1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight; // 0
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  
  return (
    <>
    <CommonRect rect={rect} />            
    <NShelves rect={rect} />
    <ToolTipHoverComponent rect={rect} />
    </>  
  );  
};

const Tx4ROx3SHx1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  rect.numshelves = 4; // one more than labeled
  rect.heightForShelves = rect.adjustedHeight/2;
  rect.numrollouts = 5;
  const arrns = Array.from({ length: rect.numrollouts}, (v, k) => k);
  const heightForRollOuts = ((rect.numshelves-1)/rect.numshelves)*rect.heightForShelves;

  return (
    <>
    <CommonRect rect={rect} />
    <NShelves rect={rect} />

    {arrns.map((arrn, i) => {
      if (i===0) {
        return;
      }
      return (
        <> 
        <Rect 
          stroke="black"
          strokeWidth={1}
          x={5}
          y={heightForRollOuts+i*(rect.adjustedHeight-heightForRollOuts)/4-25}
          width={rect.width-10}
          height={25}
        />        
        </>
      );
    })}  
    <ToolTipHoverComponent rect={rect} />

    {/**pending to add lines for doors */}    
       
    </>
  );
};


const Tx1FSx5SHx2DrxTBxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  
  return (
    <>
    <CommonRect rect={rect} />           
    <NShelves rect={rect} />    
    {/**TODO: fix to have left and right */}
    <Line
      points={[0, -rect.adjustedHeight/4, rect.width, -rect.adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.height)/2}
    />                    
    <Line
      points={[0, -rect.adjustedHeight/4, rect.width, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />        

    <Line
      points={[0, rect.adjustedHeight/4, rect.width, rect.adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />                    
    <Line
      points={[0, rect.adjustedHeight/4, rect.width, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}/>   
      <ToolTipHoverComponent rect={rect} />
    </>
  );  
};

const Tx1FSx5SHx4DrxTBxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  
  return (
    <>
    <CommonRect rect={rect} />           
    <NShelves rect={rect} />    
    {/**TODO: fix to have left and right */}
    <Line
      points={[0, -3*rect.adjustedHeight/8, rect.width, -2*rect.adjustedHeight/4]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />                    
    <Line
      points={[0, -3*rect.adjustedHeight/8, rect.width, -rect.adjustedHeight/4]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />        
    <Line
      points={[0, -rect.adjustedHeight/8, rect.width, -rect.adjustedHeight/4]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />                    
    <Line
      points={[0, -rect.adjustedHeight/8, rect.width, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />        

    <Line
      points={[0, rect.adjustedHeight/8, rect.width, rect.adjustedHeight/4]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}      
      y={0+(rect.adjustedHeight)/2}
    />                    
    <Line
      points={[0, rect.adjustedHeight/8, rect.width, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}/>   
      <ToolTipHoverComponent rect={rect} />

    <Line
      points={[0, 3*rect.adjustedHeight/8, rect.width, rect.adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}      
      y={0+(rect.adjustedHeight)/2}
    />                    
    <Line
      points={[0, 3*rect.adjustedHeight/8, rect.width, rect.adjustedHeight/4]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}/>   
      <ToolTipHoverComponent rect={rect} />      
    </>
  );  
};

//////////////////////* START BASE CORNERS */ //////////////////////////////////////

const Bx90CLx1SHx1DrxS = (props) => {
  let adjustedHeight;

  let stddeep;
  if (props.rect.cabinettype === "base_cabinet") {
    stddeep = 24*inchtopointfactor;
    adjustedHeight = props.rect.height - kicktoeheight;
  }
  else if (props.rect.cabinettype === "wall_cabinet") {
    stddeep = 13*inchtopointfactor;
    adjustedHeight = props.rect.height;
  }
  else {
    stddeep = 0;
    adjustedHeight = props.rect.height;
  }
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
  const cornerside = rect.cornerside;
    
  var doorpointsup;
  var doorpointsdown;
  var middlerect;
  if (cornerside === "L") {
    doorpointsup = [stddeep, 0, rect.width, -rect.adjustedHeight/2];
    doorpointsdown = [stddeep, 0, rect.width, rect.adjustedHeight/2];
    middlerect = [stddeep, rect.adjustedHeight/2, stddeep, -rect.adjustedHeight/2]
  }
  else if (cornerside === "R") {
    doorpointsup = [rect.width-stddeep, 0, 5, -rect.adjustedHeight/2];
    doorpointsdown = [rect.width-stddeep, 0, 5, rect.adjustedHeight/2];
    middlerect = [rect.width-stddeep, rect.adjustedHeight/2, rect.width-stddeep, -rect.adjustedHeight/2]
  }
  else {
    doorpointsup = [];
    doorpointsdown = [];
    middlerect = [];
  }
  return (
    <>
    <CommonRect rect={rect} /> 
    <Line
      points={doorpointsup}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />  
    <Line
      points={doorpointsdown}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />      
    <Line
      points={middlerect}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(rect.adjustedHeight)/2}
    />      
    <Line
      points={[5, -2.5, rect.width-5, -2.5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />          
    <Line
      points={[5, 2.5, rect.width-5, 2.5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(rect.adjustedHeight)/2}
    />     
    {/*<ToolTipHoverComponent rect={rect} />         */}
    </>
  );
};

const BxCTFFx2DWR = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  const ht = 0.8*rect.adjustedHeight;
  const numDrawersFronts = rect.compDrawers;
  const arrns = Array.from({ length: numDrawersFronts}, (v, k) => k);

  return (
    <>
    <CommonRect rect={rect} />
    {arrns.map((arrn, i) => {
      return (
        <> 
        <Line 
          points={[0, i*ht/numDrawersFronts-ht/2, rect.width, i*ht/numDrawersFronts-ht/2]}
          stroke="black"
          strokeWidth={1}
          lineJoin="round"
          y={rect.adjustedHeight*0.58}    
        />        
        <Rect 
          stroke="black"
          strokeWidth={1}
          x={rect.width/4}
          y={i*ht/numDrawersFronts+0.5*(ht+10)/numDrawersFronts}
          width={rect.width/2}
          height={4}
          cornerRadius={2}
        /> 
        </>
      );
    })}  
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

const BxMICROx1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  const ht = 0*rect.adjustedHeight;
  const numDrawersFronts = rect.compDrawers;
  const arrns = Array.from({ length: numDrawersFronts}, (v, k) => k);
  const spacebetween = rect.height>130?10:5;

  return (
    <>
    <CommonRect rect={rect} />
    {arrns.map((arrn, i) => {
      return (
        <> 
        <Line 
          points={[0, i*ht/numDrawersFronts-ht/2, rect.width, i*ht/numDrawersFronts-ht/2]}
          stroke="black"
          strokeWidth={1}
          lineJoin="round"
          y={rect.adjustedHeight*0.58}    
        />    
        <Circle
          x={rect.width/2} // X-coordinate of the circle's center
          y={rect.adjustedHeight*0.7} // Y-coordinate of the circle's center
          radius={5} // Radius of the circle
          stroke={"black"}
          strokeWidth={1}
        />
        </>
      );
    })}  
    {/**the microwave created with a rect*/}
    {(rect.width>72) &&
    <>
    <Rect
      stroke="black"
      strokeWidth={1}
      x={spacebetween/7}
      y={1.5*spacebetween}
      width={rect.width-2*spacebetween/7}
      height={0.43*rect.height}
      cornerRadius={4}
    />        
    <Rect
      strokeWidth={1}
      stroke={"black"}
      x={spacebetween}
      y={2.5*spacebetween}
      width={0.7*rect.width}
      height={rect.height*0.43-2*spacebetween}
      cornerRadius={3}
    />
    <Rect
      stroke={"black"}
      strokeWidth={1}
      x={2*spacebetween+0.7*rect.width}
      y={2.5*spacebetween}
      width={rect.width-2*spacebetween/7 - 2*spacebetween-0.7*rect.width}
      height={rect.height*0.25}
      cornerRadius={3}
    />    
    <Rect
      stroke={"black"}
      strokeWidth={1}
      x={2*spacebetween+0.7*rect.width}
      y={rect.height*0.4}
      width={rect.width-2*spacebetween/7 - 2*spacebetween-0.7*rect.width}
      height={1.1*spacebetween}
      cornerRadius={3}
    />        
    </>
    }     
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

const BxGARBx1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />

    <Line 
      points={[0, rect.adjustedHeight-30, rect.width, rect.adjustedHeight-30]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}    
    />        
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

const BxGARBx1Dwrx1DrxS = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  return (
    <>
    <CommonRect rect={rect} />

    <Line 
      points={[0, -rect.adjustedHeight+30, rect.width, -rect.adjustedHeight+30]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={rect.adjustedHeight}    
    />    
    <Rect 
      offsetY={rect.adjustedHeight}
      stroke="black"
      strokeWidth={1}
      x={rect.width/4}
      y={rect.adjustedHeight+15}    
      width={rect.width/2}
      height={4}
      cornerRadius={2}
    />         
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

//////////////////////* END BASE CORNERS */ //////////////////////////////////////


const windowElement = (props) => {
  const rect = props.rect;
  rect.fill = "lightblue";
  return (
    <>
    <CommonRect rect={rect}/>
    <Line
      points={[0, rect.height/2, rect.width, rect.height/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}
    />
    <Line
      points={[rect.width/2, 0, rect.width/2, rect.height]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0}
    />
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
}

const doorElement = (props) => {
  const rect = props.rect; 
  rect.fill = "white";
  const frameThickness = rect.height>130?10:4;
  return (
    <>
    <CommonRect rect={rect}/>
    <Rect
      x={frameThickness}
      y={frameThickness}
      width={rect.width-2*frameThickness}
      height={rect.height-frameThickness}
      opacity={1}
      stroke={"black"}
      strokeWidth={1}
    />
    <Line
      points={[0, 0, frameThickness, frameThickness]}
      stroke="black"
      strokeWidth={rect.height>130?2:1}
      lineJoin="round"
      y={0}
    />
    <Line
      points={[rect.width, 0, rect.width-frameThickness, frameThickness]}
      stroke="black"
      strokeWidth={rect.height>130?2:1}
      lineJoin="round"
      y={0}
    />    
    {(rect.height>130) &&
    <Circle
      x={rect.width-25} // X-coordinate of the circle's center
      y={rect.height/2} // Y-coordinate of the circle's center
      radius={9} // Radius of the circle
      fill="gray" // Fill color of the circle
    />    
    }
    {(rect.height<=130) &&
    <Circle
      x={rect.width-10} // X-coordinate of the circle's center
      y={rect.height/2} // Y-coordinate of the circle's center
      radius={rect.height/25} // Radius of the circle
      fill="gray" // Fill color of the circle
    />    
    }

    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

const refrigeratorElement = (props) => {
  const rect = props.rect;
  rect.fill = "white";
  return (
    <>
      <CommonRect rect={rect}/>    
      <Rect
        cornerRadius={8} // Radius of the circle
        x={0.08*rect.width}
        y={0.05*rect.height}
        width={rect.width/20}
        height={rect.height/4}
        opacity={1}
        fill={"black"}
        stroke={"black"}
      />
      <Line
        points={[0, rect.height/3, rect.width, rect.height/3]}
        stroke="black"
        strokeWidth={1}
        lineJoin="round"
        y={0}
        fill={"black"}
      />
      <Rect
        cornerRadius={8} // Radius of the circle
        x={0.08*rect.width}
        y={0.4*rect.height}
        width={rect.width/20}
        height={rect.height/4}
        opacity={1}
        fill={"black"}
        stroke={"black"}
      />       

      {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

const wallMountRangeHoodElement = (props) => {
  const rect = props.rect;
  rect.fill = "lightgray";
  rect.stroke = "lightgray";
  return (
    <>  
    <CommonRect rect={rect}/>
    <Rect 
      x={rect.width/4}
      y={0}
      width={rect.width/2}
      height={rect.height*0.85}
      stroke={"black"}
      strokeWidth={1}
      fill={"gray"}
      opacity={0.4}
    />
    <Rect 
      x={0}
      y={rect.height*0.85}
      width={rect.width}
      height={rect.height*0.15}
      stroke={"black"}
      strokeWidth={1}
      fill={"gray"}
      opacity={0.4}      
    />         
    {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
};

const dishwasherElement = (props) => {
  const rect = props.rect;
  rect.fill = "white";
  return (
    <>
      <CommonRect rect={rect}/>
      <Rect
        x={0}
        y={rect.height-10}
        width={rect.width}
        height={10}
        cornerRadius={2} // Applies 10px radius to all corners
        fill={"black"}
        opacity={0.5}
        stroke="black"
        strokeWidth={1}  
      />
      <Rect
        x={0}
        y={0}
        width={rect.width}
        height={20}
        cornerRadius={2} // Applies 10px radius to all corners
        fill={"silver"}
        opacity={0.4}
        stroke="black"
        strokeWidth={1}  
      />    
      <Rect
        x={20}
        y={20}
        width={rect.width-40}
        height={8}
        fill={"black"}
        opacity={0.5}
        stroke="black"
        strokeWidth={1}  
      />            
      {/*<ToolTipHoverComponent rect={rect} />*/}
    </>
  );
}

const stoveElement = (props) => {
  const rect = props.rect; 
  rect.fill = "white";
  const arrns = Array.from({ length: 6}, (v, k) => k);
  return (
    <>    
    <CommonRect rect={rect}/>
    {arrns.map((arrn, i) => {
      if (i<2 || i>3) {
        return (  
          <Circle
            x={((i+0.5)/arrns.length)*rect.width} // X-coordinate of the circle's center
            y={rect.height>130?30:rect.height/10} // Y-coordinate of the circle's center
            radius={rect.height>130?8:rect.height/20} // Radius of the circle
            fill="gray" // Fill color of the circle
          />
        );
      }
      else {
        return null;
      }
    })}
    <Rect
      x={rect.width/8}
      y={-5}
      width={rect.width/4}
      height={5}
      stroke="black"
      fill={"black"}
      strokeWidth={1}  
    />
    <Rect
      x={5*rect.width/8}
      y={-5}
      width={rect.width/4}
      height={5}
      stroke="black"
      fill={"black"}
      strokeWidth={1}  
    />    

    <Rect
      x={rect.height>130?10:rect.height/20}
      y={0.25*rect.height}
      width={rect.height>130?rect.width-20:0.85*rect.width}
      height={rect.height*0.45}
      cornerRadius={2} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />

    <Rect
      x={rect.width/4}
      y={0.85*rect.height}
      width={rect.width/2}
      height={5}
      cornerRadius={2} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />
    <Line
      points={[0, 0.2*rect.height, rect.width, 0.2*rect.height]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      fill={"black"}
    />                    

    <Line
      points={[0, 0.85*rect.height, rect.width, 0.85*rect.height]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      fill={"black"}
    />   
    {/*<ToolTipHoverComponent rect={rect} />                 */}
    </>
  );
};

const InsideRectAndToolTip = (props) => {
  const rect = props.rect; 
  const [tooltipProp, setTooltipProp] = useState(tooltipState);    
  
  return (
    <>
    <Rect
      x={5}
      y={5}
      width={rect.width-10}
      height={rect.height-10}
      stroke="black"
      strokeWidth={1}  

      onMouseMove={(e) => {
        e.target.setAttr("opacity", 1)
        e.target.getStage().container().style.cursor = 'pointer';

        const mousePos = e.target.getStage().getPointerPosition();
        //console.log(layerPos);
        setTooltipProp({
          fill: 'black',
          text: `${rect.cabinetConfig}\nW=${rect.width/inchtopointfactor}, H=${rect.height/inchtopointfactor}, D=${24}`,          
          visible: true,
          x: mousePos.x - rect.x + 10, //mousePos.x - 90,
          y: mousePos.y - rect.y
        });        

      }}                   
      onMouseLeave={(e) => {
        if (!rect.selected) {
          e.target.setAttr("opacity", normalopacity);                          
        }
        e.target.getStage().container().style.cursor = 'default';                      
        setTooltipProp(prev => ({ ...prev, visible: false }));
      }}       
    />                 
    <Group x={0} y={0}>
      <Rect
        visible={tooltipProp.visible}
        width={100}
        height={25}
        x={tooltipProp.x}
        y={tooltipProp.y}
        fill="lightblue"
        stroke="blue"
        strokeWidth={1}
        opacity={1}
      />      
      <Text
        {...tooltipProp}
        fontFamily="Calibri"
        fontSize={14}
        padding={5}
        fill="black"
        opacity={0.75}
      />

    </Group>        
    </>
  );
};

const NShelves = (props) => {
  const rect = props.rect; 
  const heightForShelves = rect.heightForShelves?rect.heightForShelves:rect.height;
  const numshelves = rect.numshelves;
  const arrns = Array.from({ length: numshelves}, (v, k) => k);

  return (
    <>
    {arrns.map((arrn, i) => {
      if (i===0) {
        return;
      }
      return (
        <> 
        <Line 
          points={[0, i*heightForShelves/numshelves-heightForShelves/2, rect.width, i*heightForShelves/numshelves-heightForShelves/2]}
          stroke="black"
          strokeWidth={1}
          lineJoin="round"
          y={0+(heightForShelves)/2}   
          dash={[5, 5]} 
        /> 
        <Line 
          points={[0, i*heightForShelves/numshelves-heightForShelves/2+5, rect.width, i*heightForShelves/numshelves-heightForShelves/2+5]}
          stroke="black"
          strokeWidth={1}
          lineJoin="round"
          y={0+(heightForShelves)/2}    
          dash={[5, 5]} 
        />            
        </>
      );
    })} 
    </>
  );
};

const Placeholder = (props) => {
  const rect = props.rect;  
  if (rect.forTallCabinetId) {
    rect.stroke = "lightgray";
  }else {
    rect.stroke = "black";
  }
  let nhash = Math.round(rect.height/inchtopointfactor); 
  const arrns = Array.from({ length:nhash}, (v, k) => k);
  return (
    <>
    {/**change fill to lightgray to ensure it is not visible */}
    <CommonRect rect={{...rect, fill:"lightgray", dash:[10, 5]}} /> 
    {/* hashed fill to indicate placeholder */}
  
    {arrns.map((arrn, i) => {
      return (
        <Line
          dash={[8,4]}
          dashEnabled={true}
          opacity={0.4}
          key={i}
          points={[0, (i+1)*rect.height/nhash, rect.width, (i)*rect.height/nhash]}
          stroke="gray"
          strokeWidth={1}
          lineJoin="round"
          y={0}   
        />
      );
    })}
    {(rect.cabinettype==='wall_cabinet' || rect.width<=12) && //rect.width<=12
    <Circle
      x={rect.width/2} // X-coordinate of the circle's center
      y={rect.cabinettype==='wall_cabinet'?0:rect.height} // Y-coordinate of the circle's center
      radius={5} // Radius of the circle
      fill="lightgray" // Fill color of the circle
      stroke={"black"}
      strokeWidth={1}
    />    
    }
    <ToolTipHoverComponent rect={rect} />
    </>  
  );  
};

const CornerCabinetAdjacentWall = (props) => {
  let adjustedHeight;

  if (props.rect.cabinettype === "base_cabinet") {
    adjustedHeight = props.rect.height - kicktoeheight;
  }
  else if (props.rect.cabinettype === "wall_cabinet") {
    adjustedHeight = props.rect.height;
  }

  const rect = {...props.rect, adjustedHeight: adjustedHeight};  
;
  rect.fill = 'white';
  return (
    <>    
    <CommonRect rect={rect} />
    <ToolTipHoverComponent rect={rect} />    
    </>
  );
};

const CornerCabinetAdjacentWallFillerPlusDoor = (props) => {
  let adjustedHeight;

  if (props.rect.cabinettype === "base_cabinet") {
    adjustedHeight = props.rect.height - kicktoeheight;
  }
  else if (props.rect.cabinettype === "wall_cabinet") {
    adjustedHeight = props.rect.height;
  }

  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  rect.fill = 'white';
  let fillerposx;
  if (rect.cornerside === "L") {
    fillerposx = rect.width - 12;    
  }
  if (rect.cornerside === "R") {
    fillerposx = 0;      
  }

  const fillerrect = {...rect, x: fillerposx}

  return (
    <>    
    <CommonRect rect={rect} />
    <FillerPanel rect={fillerrect}/>    
    <ToolTipHoverComponent rect={rect} />    
    </>
  );
};

const CornerCabinetAdjacentWallLeman = (props) => {
  const adjustedHeight = props.rect.height - kicktoeheight;
  const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  rect.fill = 'white';
  let fillerposx;
  if (rect.cornerside === "L") {
    fillerposx = rect.width - 12;    
  }
  if (rect.cornerside === "R") {
    fillerposx = 0;      
  }

  const fillerrect = {...rect, x: fillerposx}

  return (
    <>    
    <CommonRect rect={rect} />
    <FillerPanel rect={fillerrect}/>    
    <ToolTipHoverComponent rect={rect} />    
    </>
  );
};


const FillerPanel = (props) => {
  //const adjustedHeight = props.rect.height - kicktoeheight;
  //const rect = {...props.rect, adjustedHeight: adjustedHeight};  

  let adjustedHeight;

  if (props.rect.cabinettype === "base_cabinet") {
    adjustedHeight = props.rect.height - kicktoeheight;
  }
  else if (props.rect.cabinettype === "wall_cabinet") {
    adjustedHeight = props.rect.height;
  }

  const rect = {...props.rect, adjustedHeight: adjustedHeight};    

  return (
    <>    
    <Rect
      x={rect.x}
      y={0}
      width={12}
      height={rect.adjustedHeight}   
      stroke={rect.stroke?rect.stroke:"black"} 
      strokeWidth={1}
    />
    <Text 
      align='center'
      width={rect.width}
      text={Math.round((rect.width-12)/6*100)/100 + 'in+2in (door+panel)'}
      x={0}
      y={15}
    />
    <ToolTipHoverComponent rect={rect} />        
    </>
  ); 
}



//////////////////////////////////////////////////////////////////////////

const AllCabinetConfigs = [
  /* BASE CABINETS */  
  {
    "cabtype":"base_cabinet",
    "configname": "---------- STANDARD BASE CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "Standard Base Cabinet 1 Shelf, 1 Door, L",
    "configid":"B:1SH-1DR-L",
    "configcomponentname": Bx1SHx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1
  },
  {
    "cabtype":"base_cabinet",
    "configname": "Standard Base Cabinet 1 Shelf, 1 Door, R",
    "configid":"B:1SH-1DR-R",
    "configcomponentname": Bx1SHx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "Standard Base Cabinet 1 Shelf, 2 Doors",
    "configid":"B:1SH-2DR",
    "configcomponentname": Bx1SHx1DRxS,  
    "widthMin": 24,
    "widthMax": 48,
    "side":"LR",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 2    
  },
  {
    "cabtype":"base_cabinet",
    "configname": "Standard Base Cabinet 2 Roll Outs, 1 Door, L",
    "configid":"B:2RO-1DR-L",
    "configcomponentname": Bx2ROx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"L",
    "compDrawers": 0,
    "compRollouts": 2,
    "compShelves": 0,
    "compDoors": 1    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "Standard Base Cabinet 2 Roll Outs, 1 Door, R",
    "configid":"B:2RO-1DR-R",
    "configcomponentname": Bx2ROx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"R",
    "compDrawers": 0,
    "compRollouts": 2,
    "compShelves": 0,
    "compDoors": 1    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "Standard Base Cabinet 2 Roll Outs, 2 Doors",
    "configid":"B:2RO-2DR",
    "configcomponentname": Bx2ROx1DRxS, 
    "widthMin": 24,
    "widthMax": 36,
    "side":"LR",
    "compDrawers": 0,
    "compRollouts": 2,
    "compShelves": 0,
    "compDoors": 2    
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "---------- PULL OUT BASE CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Wooden Pull Out Cabinet 9in, 1 Door",
    "configid":"B:PO-Wd1Dr-S",
    "configcomponentname": BxPOxWd1DrxS, 
    "widthMin": 9,
    "widthMax": 9,
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1    
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Wooden Pull Out Cabinet 11in, 1 Door",
    "configid":"B:PO-Wd1Dr-L",
    "configcomponentname": BxPOxWd1DrxS, 
    "widthMin": 11,
    "widthMax": 11,
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1    
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "---------- TOP DRAWER BASE CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },     
  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawer Base Cabinet 1 Shelf, 1 Top Drawer, 1 Door, L",
    "configid":"B:1DWR-1SH-1DR-L",
    "configcomponentname": Bx1DWRx1SHx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"L",
    "compDrawers": 1,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1    
  },         
  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawer Base Cabinet 1 Shelf, 1 Top Drawer, 1 Door, R",
    "configid":"B:1DWR-1SH-1DR-R",
    "configcomponentname": Bx1DWRx1SHx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"R",
    "compDrawers": 1,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1    
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawer Base Cabinet 1 Shelf, 1 Top Drawer, 2 Doors",
    "configid":"B:1DWR-1SH-2DR",
    "configcomponentname": Bx1DWRx1SHx1DRxS, 
    "widthMin": 24,
    "widthMax": 36,
    "side":"LR",
    "compDrawers": 1,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 2    
  },       



  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawer Base Cabinet 2 Roll Outs, 1 Top Drawer, 1 Door, L",
    "configid":"B:1DWR-2RO-1DR-L",
    "configcomponentname": Bx1DWRx2ROx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"L",
    "compDrawers": 1,
    "compRollouts": 2,
    "compShelves": 0,
    "compDoors": 1    
  },         
  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawer Base Cabinet 2 Roll Outs, 1 Top Drawer, 1 Door, R",
    "configid":"B:1DWR-2RO-1DR-R",
    "configcomponentname": Bx1DWRx2ROx1DRxS, 
    "widthMin": 12,
    "widthMax": 24,
    "side":"R",
    "compDrawers": 1,
    "compRollouts": 2,
    "compShelves": 0,
    "compDoors": 1    
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawer Base Cabinet 2 Roll Outs, 1 Top Drawer, 2 Doors",
    "configid":"B:1DWR-2RO-2DR",
    "configcomponentname": Bx1DWRx2ROx1DRxS, 
    "widthMin": 24,
    "widthMax": 36,
    "side":"LR",
    "compDrawers": 1,
    "compRollouts": 2,
    "compShelves": 0,
    "compDoors": 2    
  },         
  {
    "cabtype":"base_cabinet",
    "configname": "Top Drawers Base Cabinet 1 Shelf, 2 Top Drawers, 2 Doors",
    "configid":"B:2DWr-1SH-2DR",
    "configcomponentname": Bx2DWrx1SHx2DR, 
    "widthMin": 24,
    "widthMax": 48,
    "side":"LR",
    "compDrawers": 2,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 2    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "---------- DRAWER BASE CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },     
  {
    "cabtype":"base_cabinet",
    "configname": "2 Drawer Fronts",
    "numDrawersFronts": 2,
    "configid":"B:2Dwr",
    "configcomponentname": BxSDwr, 
    "widthMin": 12,
    "widthMax": 36,
    "side":"NA",
    "compDrawers": 2,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "3 Drawer Fronts",
    "numDrawersFronts": 3,
    "configid":"B:3Dwr",
    "configcomponentname": BxSDwr, 
    "widthMin": 12,
    "widthMax": 36,
    "side":"NA",
    "compDrawers": 3,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "4 Drawer Fronts",
    "numDrawersFronts": 4,
    "configid":"B:4Dwr",
    "configcomponentname": BxSDwr, 
    "widthMin": 12,
    "widthMax": 36,
    "side":"NA",
    "compDrawers": 4,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "---------- SINK FALSE FRONT CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },     
  {
    "cabtype":"base_cabinet",
    "configname": "Sink Base 1 Door, L",
    "configid":"B:SINK-1Dr-L",
    "configcomponentname": BxSINKx1DrxS, 
    "widthMin": 15,
    "widthMax": 24,
    "side":"L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "Sink Base 1 Door, R",
    "configid":"B:SINK-1Dr-R",
    "configcomponentname": BxSINKx1DrxS, 
    "widthMin": 15,
    "widthMax": 24,
    "side":"R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1    
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "Sink Base 2 Doors",
    "configid":"B:SINK-2Dr",
    "configcomponentname": BxSINKx1DrxS, 
    "widthMin": 24,
    "widthMax": 42,
    "side":"LR",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2    
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "---------- BASE APPLIANCES ----------",
    "configid":"unsel", // this configid is not selectable
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "Base Cooktop: False Front",
    "configid":"B:CTFF-2DWR",
    "configcomponentname": BxCTFFx2DWR, 
    "widthMin": 12,
    "widthMax": 30,
    "side":"NA",
    "compDrawers": 2,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2    
  },     
  {
    "cabtype":"base_cabinet",
    "configname": "Base Microwave: Appliance Panel",
    "configid":"B:MICRO-1Dr",
    "configcomponentname": BxMICROx1DrxS, 
    "widthMin": 12,
    "widthMax": 30,
    "side":"NA",
    "compDrawers": 2,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1    
  },     
  {
    "cabtype":"base_cabinet",
    "configname": "Base Single Trash Unit, 1 Pull Out",
    "configid":"B:GARB-1DR-S",
    "configcomponentname": BxGARBx1DrxS, 
    "widthMin": 12,
    "widthMax": 15,
    "side":"NA",
    "compDrawers": 1,
    "compRollouts": 1,
    "compShelves": 0,
    "compDoors": 1    
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "Base Double Trash Unit, 1 Pull Out",
    "configid":"B:GARB-1DR-D",
    "configcomponentname": BxGARBx1DrxS, 
    "widthMin": 18,
    "widthMax": 21,
    "side":"NA",
    "compDrawers": 1,
    "compRollouts": 1,
    "compShelves": 0,
    "compDoors": 1    
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Base Double Trash Unit, 1 Drawer",
    "configid":"B:GARB-1Dwr-1DR-D",
    "configcomponentname": BxGARBx1Dwrx1DrxS, 
    "widthMin": 18,
    "widthMax": 21,
    "side":"NA",
    "compDrawers": 1,
    "compRollouts": 1,
    "compShelves": 0,
    "compDoors": 1    
  },   






  {
    "cabtype":"base_cabinet",
    "configname": "90 Corner Base L, 1 Shelf",
    "configid":"B:90CL-1SH-1Dr-L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 36,
    "widthMax": 36,
    "side":"NA",
    "cornerside": "L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 2    
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "90 Corner Base R, 1 Shelf",
    "configid":"B:90CR-1SH-1Dr-R",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 36,
    "widthMax": 36,
    "side":"NA",
    "cornerside": "R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 2     
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "90 Corner Base Lazy Susan, L",
    "configid":"B:90CL-LS-1Dr-L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 36,
    "widthMax": 36,
    "side":"NA",
    "cornerside": "L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2    
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "90 Corner Base Lazy Susan, R",
    "configid":"B:90CR-LS-1Dr-R",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 36,
    "widthMax": 36,
    "side":"NA",
    "cornerside": "R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2        
  },  
  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner, 1 Shelf, L",
    "configid":"B:BL-1SH-1Dr",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 39,
    "widthMax": 48,
    "side":"NA",
    "cornerside": "L",  
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1      
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner, 1 Shelf, R",
    "configid":"B:BR-1SH-1Dr",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 39,
    "widthMax": 48,
    "side":"NA",
    "cornerside": "R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1      
  },    
  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner Lemans 245L, L",
    "configid":"B:BL-Lemans245L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 34,
    "widthMax": 34,
    "side":"NA",
    "cornerside": "L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },     

  /* BASE CORNER CABINETS */
  /* CORNER BASE CABINET FROM THE ADJACENT WALL */
  /* It should not be selectable and it should not be shown in the table of cabinets */
  {
    "cabtype":"base_cabinet",
    "configname": "Adjacent Corner Base Cabinet, R",
    "configid":"AdjacentCornerBaseCabinet",
    "configcomponentname": CornerCabinetAdjacentWall, 
    "widthMin": 24,
    "widthMax": 24,
    "side":"NA",
    "cornerside": "R",
    "showInTable": false,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  {
    "cabtype":"base_cabinet",
    "configname": "Adjacent Corner Base Cabinet, L",
    "configid":"AdjacentCornerBaseCabinet",
    "configcomponentname": CornerCabinetAdjacentWall, 
    "widthMin": 24,
    "widthMax": 24,
    "side":"NA",
    "cornerside": "L",
    "showInTable": false,  
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0     
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "Adjacent Corner Base Cabinet, Lemans, L",
    "configid":"AdjacentCornerBaseCabinetLemanL",
    "configcomponentname": CornerCabinetAdjacentWallLeman, 
    "widthMin": 26, // 24 + 1(door) + 1(panel)
    "widthMax": 26,
    "side":"NA",
    "cornerside": "L",
    "showInTable": false,  
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0     
  },   
  {
    "cabtype":"base_cabinet",
    "configname": "Adjacent Corner Base Cabinet, Lemans, R",
    "configid":"AdjacentCornerBaseCabinetLemanR",
    "configcomponentname": CornerCabinetAdjacentWallLeman, 
    "widthMin": 26, // 24 + 1(door) + 1(panel)
    "widthMax": 26,
    "side":"NA",
    "cornerside": "R",
    "showInTable": false,  
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0     
  },  
  {
    "cabtype":"wall_cabinet",
    "configname": "Adjacent Corner Upper Cabinet, R",
    "configid":"AdjacentCornerUpperCabinet",
    "configcomponentname": CornerCabinetAdjacentWall, 
    "widthMin": 13,  
    "widthMax": 13,
    "allowedHeights": [36, 38, 40],
    "side":"NA",
    "cornerside": "R",
    "showInTable": false,   
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  {
    "cabtype":"wall_cabinet",
    "configname": "Adjacent Corner Upper Cabinet, L",
    "configid":"AdjacentCornerUpperCabinet",
    "configcomponentname": CornerCabinetAdjacentWall, 
    "widthMin": 13,  
    "widthMax": 13,  
    "allowedHeights": [36, 38, 40],
    "side":"NA",
    "cornerside": "L",
    "showInTable": false,   
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },   

  {
    "cabtype":"wall_cabinet",
    "configname": "Adjacent Corner Upper Cabinet FillerPlusDoor, R",
    "configid":"AdjacentCornerUpperCabinetFillerPlusDoorR",
    "configcomponentname": CornerCabinetAdjacentWallFillerPlusDoor, 
    "widthMin": 15, // 13 + 2 (filler+door)  
    "widthMax": 15,
    "allowedHeights": [36, 38, 40],
    "side":"NA",
    "cornerside": "R",
    "showInTable": false,   
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  {
    "cabtype":"wall_cabinet",
    "configname": "Adjacent Corner Upper Cabinet FillerPlusDoor, L",
    "configid":"AdjacentCornerUpperCabinetFillerPlusDoorL",
    "configcomponentname": CornerCabinetAdjacentWallFillerPlusDoor, 
    "widthMin": 15, // 13 + 2 (filler+door)    
    "widthMax": 15,
    "allowedHeights": [36, 38, 40],
    "side":"NA",
    "cornerside": "L",
    "showInTable": false,   
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },     

  ////////////////////////////

  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner Lemans 245L, R",
    "configid":"B:BR-Lemans245L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 34,
    "widthMax": 34,
    "side":"NA",
    "cornerside": "R",   
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1     
  },        

  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner Lemans 250L, L",
    "configid":"B:BL-Lemans250L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 38,
    "widthMax": 38,
    "side":"NA",
    "cornerside": "L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner Lemans 250L, R",
    "configid":"B:BR-Lemans250L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 38,
    "widthMax": 38,
    "side":"NA",
    "cornerside": "R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },     
  
  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner Lemans 260L, L",
    "configid":"B:BL-Lemans260L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 39.5,
    "widthMax": 39.5,
    "side":"NA",
    "cornerside": "L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Base Blind Corner Lemans 260L, R",
    "configid":"B:BR-Lemans260L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 39.5,
    "widthMax": 39.5,
    "side":"NA",
    "cornerside": "R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },       

  /* WALL CABINETS */  
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Blind Upper Corner, 2 Shelves, L",
    "configid":"W:BL-2SH-1Dr-L",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 28,
    "widthMax": 40,
    "side":"NA",
    "cornerside": "L",
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 2,
    "compDoors": 1        
  },     
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Blind Upper Corner, 2 Shelves, R",
    "configid":"W:BL-2SH-1Dr-R",
    "configcomponentname": Bx90CLx1SHx1DrxS, 
    "widthMin": 28,
    "widthMax": 40,
    "side":"NA",
    "cornerside": "R" ,
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 2,
    "compDoors": 1           
  },    
  {
    "cabtype":"wall_cabinet",
    "configname": "Corner Wall Filler, L",
    "configid":"FillerEndPanel",
    "configcomponentname": FillerEndPanels,
    "widthMin": 2,
    "widthMax": 2,
    "side":"NA",
    "cornerside": "L",      
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  {
    "cabtype":"wall_cabinet",
    "configname": "Corner Wall Filler, R",
    "configid":"FillerEndPanel",
    "configcomponentname": FillerEndPanels,
    "widthMin": 2,
    "widthMax": 2,
    "side":"NA",
    "cornerside": "R",
    "allowedHeights": [34.5, 36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0          
  },       
  {
    "cabtype":"base_cabinet",
    "configname": "Corner Base Filler, L",
    "configid":"FillerEndPanel",
    "configcomponentname": FillerEndPanels,
    "widthMin": 2,
    "widthMax": 2,
    "side":"NA",
    "cornerside": "L",
    "allowedHeights": [34.5, 36, 38, 40],  // added 34.5 
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0          
  }, 
  {
    "cabtype":"base_cabinet",
    "configname": "Corner Base Filler, R",
    "configid":"FillerEndPanel",
    "configcomponentname": FillerEndPanels,
    "widthMin": 2,
    "widthMax": 2,
    "side":"NA",
    "cornerside": "R",
    "allowedHeights": [34.5, 36, 38, 40],  // added 34.5 
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0          
  },     


  /* UPPER CABINETS */  
  {
    "cabtype":"wall_cabinet",
    "configname": "---------- STANDARD UPPER CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },       
  {
    "cabtype":"wall_cabinet",
    "configname": "Standard Upper Cabinet 1 Door, 2 Shelves, L",
    "configid":"W:2Sh-1DR-L",
    "configcomponentname": Wx2Shx1DRxS, 
    "widthMin": 15,
    "widthMax": 24,
    "side":"L",
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 2,
    "compDoors": 1    
  },   
  {
    "cabtype":"wall_cabinet",
    "configname": "Standard Upper Cabinet 1 Door, 2 Shelves, R",
    "configid":"W:2Sh-1DR-R",
    "configcomponentname": Wx2Shx1DRxS, 
    "widthMin": 15,
    "widthMax": 24,
    "side":"R",
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 2,
    "compDoors": 1        
  },     
  {
    "cabtype":"wall_cabinet",
    "configname": "Standard Upper Cabinet 2 Doors, 2 Shelves",
    "configid":"W:2Sh-2DR",
    "configcomponentname": Wx2Shx1DRxS, 
    "widthMin": 24,
    "widthMax": 48,
    "side":"LR",
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 2,
    "compDoors": 2        
  },     
  {
    "cabtype":"wall_cabinet",
    "configname": "---------- VERTICAL LIFT UPPER CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },         
  {
    "cabtype":"wall_cabinet",
    "configname": "Vertical Lift Upper Cabinet 1 Door",
    "configid":"W:V-1Dr",
    "configcomponentname": WxVx1Dr, 
    "widthMin": 30,
    "widthMax": 48,
    "side":"NA",
    "allowedHeights": [12, 18, 19, 20, 24],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },       
  {
    "cabtype":"wall_cabinet",
    "configname": "Vertical Lift Upper Cabinet 1 Shelf, 1 Door",
    "configid":"W:V-1SH-1Dr",
    "configcomponentname": WxVx1SHx1Dr, 
    "widthMin": 24,
    "widthMax": 48,
    "side":"NA",
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 1,
    "compDoors": 1    
  },    
  {
    "cabtype":"wall_cabinet",
    "configname": "---------- WALL FRIDGE UPPER CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },           
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Fridge: No Shelves, 2 Doors, Left Panel",
    "configid":"R:2Dr-LP",
    "configcomponentname": Rx2DRxS, 
    "widthMin": 30,
    "widthMax": 48,
    "side":"LR",
    "panelSide":"L",
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2        
  },      
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Fridge: No Shelves, 2 Doors, Right Panel",
    "configid":"R:2Dr-RP",
    "configcomponentname": Rx2DRxS, 
    "widthMin": 30,
    "widthMax": 48,
    "side":"LR",
    "panelSide":"R",
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2        
  },  
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Fridge: No Shelves, 2 Doors, Both Panels",
    "configid":"R:2Dr-BP",
    "configcomponentname": Rx2DRxS, 
    "widthMin": 30,
    "widthMax": 48,
    "side":"LR",
    "panelSide":"LR",
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2        
  },    
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Fridge: Lift Wall Cabinet, 1 Door, Left Panel",
    "configid":"R:V-1Dr-LP",
    "configcomponentname": Rx1DrxS, 
    "widthMin": 30,
    "widthMax": 48,   
    "panelSide":"L", 
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0        
  },    
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Fridge: Lift Wall Cabinet, 1 Door, Right Panel",
    "configid":"R:V-1Dr-RP",
    "configcomponentname": Rx1DrxS, 
    "widthMin": 30,
    "widthMax": 48,   
    "panelSide":"R", 
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0        
  },      
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Fridge: Lift Wall Cabinet, 1 Door, Both Panels",
    "configid":"R:V-1Dr-BP",
    "configcomponentname": Rx1DrxS, 
    "widthMin": 30,
    "widthMax": 48,   
    "panelSide":"LR", 
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0        
  },       
  {
    "cabtype":"wall_cabinet",
    "configname": "---------- WALL HOOD UPPER CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },             
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Hood: No Shelves, 2 Doors",
    "configid":"WH:2Dr",
    "configcomponentname": Wx2DRxS, 
    "widthMin": 30,
    "widthMax": 48,
    "side":"LR",
    "allowedHeights": [10, 12, 14, 16, 18, 20, 22, 27], //////
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 2        
  },   
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Hood: 1 Door, Lift Wall Cabinet",
    "configid":"WH:V-1Dr",
    "configcomponentname": WxVx1Dr, 
    "widthMin": 30,
    "widthMax": 48,
    "side":"NA",
    "allowedHeights": [10, 18, 19, 20, 24, 27], /////
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 1        
  },   
  // this needs to be hidden and not selectable, it's only used as a placeholder when the user selects a wall hood without upper cabinets
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Mount Range Hood",
    "configid":":upperwallMountRangeHoodElement",
    "configcomponentname": wallMountRangeHoodElement, 
    "side":"NA",
    "initialHeight": 20,
    "initialWidth": 30,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },  
  
  {
    "cabtype":"wall_cabinet",
    "configname": "Window",
    "configid":":upperwindowElement",
    "configcomponentname": windowElement, 
    "side":"NA",
    "initialHeight": 40,
    "initialWidth": 40,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    

  /* I don't think we need this one
  {
    "cabtype":"wall_cabinet",
    "configname": "Blank Placeholder for Tall Cabinets",
    // the name below is used when inserting a cabinet to skip collision check
    // if you change it here..
    // you have to change it there as well
    "configid":"W:placeholder_for_tall_cabinets", 
    "configcomponentname": Placeholder, 
    "side":"NA"
  },  
  */  

  /* TALL CABINETS */  
  {
    "cabtype":"tall_cabinet",
    "configname": "---------- STANDARD TALL CABINETS ----------",
    "configid":"unsel", // this configid is not selectable
  },             
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall 4 Shelves, 1 Door, L",
    "numshelves": 5, // one more than above
    "configid":"T:4SH-1Dr-L",
    "configcomponentname": Tx4SHx1DrxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 4,
    "compDoors": 1    
  },         
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall 4 Shelves, 1 Door, R",
    "numshelves": 5, // one more than above
    "configid":"T:4SH-1Dr-R",
    "configcomponentname": Tx4SHx1DrxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 4,
    "compDoors": 1    
  },           
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall 4 Shelves, 2 Doors",
    "numshelves": 5, // one more than above
    "configid":"T:4SH-2Dr",
    "configcomponentname": Tx4SHx1DrxS, 
    "widthMin": 24,
    "widthMax": 48,
    "allowedHeights": [92, 94, 96],
    "side":"LR",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 4,
    "compDoors": 2    
  },
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall 4 Roll Outs, 3 Shelves, 1 Door, L",
    "numshelves": 5, // one more than above
    "configid":"T:3SH-4RO-1Dr-L",
    "configcomponentname": Tx4ROx3SHx1DrxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"L",
    "compDrawers": 0,
    "compRollouts": 4,
    "compShelves": 3,
    "compDoors": 1    
  },  
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall 4 Roll Outs, 3 Shelves, 1 Door, R",
    "numshelves": 4, // one more than above
    "configid":"T:3SH-4RO-1Dr-R",
    "configcomponentname": Tx4ROx3SHx1DrxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"R",
    "compDrawers": 0,
    "compRollouts": 4,
    "compShelves": 3,
    "compDoors": 1    
  },  
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall 4 Roll Outs, 3 Shelves, 2 Doors",
    "numshelves": 4, // one more than above
    "configid":"T:3SH-4RO-2Dr",
    "configcomponentname": Tx4ROx3SHx1DrxS, 
    "widthMin": 24,
    "widthMax": 36,
    "allowedHeights": [92, 94, 96],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 4,
    "compShelves": 3,
    "compDoors": 2    
  },    
  {
    "cabtype":"tall_cabinet",
    "configname": "---------- STANDARD TALL CABINETS TB ----------",
    "configid":"unsel", // this configid is not selectable
  },               
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB 5 Shelves, 2 Doors, L",
    "numshelves": 6, // one more than above
    "configid":"T:1FS-4SH-4Dr-TB-L",
    "configcomponentname": Tx1FSx5SHx2DrxTBxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 5,
    "compDoors": 2    
  },     
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB 5 Shelves, 2 Doors, R",
    "numshelves": 6, // one more than above
    "configid":"T:1FS-4SH-4Dr-TB-R",
    "configcomponentname": Tx1FSx5SHx2DrxTBxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 5,
    "compDoors": 2    
  },   
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB 5 Shelves, 4 Doors",
    "numshelves": 6, // one more than above
    "configid":"T:1FS-4SH-4Dr-TB",
    "configcomponentname": Tx1FSx5SHx4DrxTBxS, 
    "widthMin": 24,
    "widthMax": 48,
    "allowedHeights": [92, 94, 96],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 5,
    "compDoors": 4    
  },       

  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB 4 Roll Outs, 3 Shelves, 2 Doors, L",
    "numshelves": 4, // one more than above
    "configid":"T:1FS-2SH-4RO-2Dr-TB-L",
    "configcomponentname": Tx4ROx3SHx1DrxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"L",
    "compDrawers": 0,
    "compRollouts": 4,
    "compShelves": 3,
    "compDoors": 2    
  },  
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB 4 Roll Outs, 3 Shelves, 2 Doors, R",
    "numshelves": 4, // one more than above
    "configid":"T:1FS-2SH-4RO-2Dr-TB-R",
    "configcomponentname": Tx4ROx3SHx1DrxS, 
    "widthMin": 12,
    "widthMax": 24,
    "allowedHeights": [92, 94, 96],
    "side":"R",
    "compDrawers": 0,
    "compRollouts": 4,
    "compShelves": 3,
    "compDoors": 2    
  },    
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB 4 Roll Outs, 3 Shelves, 4 Doors",
    "numshelves": 4, // one more than above
    "configid":"T:1FS-2SH-4RO-4Dr-TB",
    "configcomponentname": Tx4ROx3SHx1DrxS, 
    "widthMin": 24,
    "widthMax": 36,
    "allowedHeights": [92, 94, 96],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 4,
    "compShelves": 3,
    "compDoors": 4    
  },   
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall TB, Double Oven, 2 Doors",
    "numshelves": 1, // one more than above
    "configid":"O:1FS-1DW-2Dr",
    "configcomponentname": Ox1FSx1DWx2Dr, 
    "widthMin": 24,
    "widthMax": 30,
    "allowedHeights": [92, 94, 96],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },   


  /** KITCHEN ELEMENTS */
  /* These are not appliance cabinets, only kitchen elements*/
  {
    "cabtype":"appliances",
    "configname": "Window",
    "configid":":applianceswindowElement",
    "configcomponentname": windowElement, 
    "side":"R",
    "initialHeight": 40,
    "initialWidth": 40,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    
  {
    "cabtype":"appliances",
    "configname": "Door, R",
    "configid":":doorElement",
    "configcomponentname": doorElement, 
    "side":"R",
    "initialHeight": 80,
    "initialWidth": 30,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },  
  {
    "cabtype":"appliances",
    "configname": "Refrigerator, R",
    "configid":"B:refrigeratorElement",
    "configcomponentname": refrigeratorElement, 
    "side":"R",
    "initialHeight": 80,
    "initialWidth": 30,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    
  {
    "cabtype":"appliances",
    "configname": "Stove",
    "configid":":stoveElement",
    "configcomponentname": stoveElement, 
    "side":"NA",
    "initialHeight": 36,
    "initialWidth": 30,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0       
  },   
  {
    "cabtype":"appliances",
    "configname": "Dishwasher",
    "configid":":dishWasherElement",
    "configcomponentname": dishwasherElement, 
    "side":"NA",
    "initialHeight": 34.5,
    "initialWidth": 24,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    
  {
    "cabtype":"appliances",
    "configname": "Wall Mount Range Hood",
    "configid":":applianceswallMountRangeHoodElement",
    "configcomponentname": wallMountRangeHoodElement, 
    "side":"NA",
    "initialHeight": 20,
    "initialWidth": 30,
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },  

  // no wall corner 
  {
    "cabtype":"wall_cabinet",
    "configname": "No Wall Corner Cabinet at the Left Side",
    "configid":"NoCornerCabinet",
    "configcomponentname": NoCornerPlaceholder,
    "widthMin": epsilon,
    "widthMax": 20,
    "side":"NA",
    "cornerside": "L",      
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  {
    "cabtype":"wall_cabinet",
    "configname": "No Wall Corner Cabinet at the Right Side",
    "configid":"NoCornerCabinet",
    "configcomponentname": NoCornerPlaceholder,
    "widthMin": epsilon,
    "widthMax": 20,
    "side":"NA",
    "cornerside": "R",      
    "allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  // no base corner
  {
    "cabtype":"base_cabinet",
    "configname": "No Base Corner Cabinet at the Left Side",
    "configid":"NoCornerCabinet",
    "configcomponentname": NoCornerPlaceholder,
    "widthMin": epsilon,
    "widthMax": 20,
    "side":"NA",
    "cornerside": "L",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0          
  }, 
  {
    "cabtype":"base_cabinet",
    "configname": "No Base Corner Cabinet at the Right Side",
    "configid":"NoCornerCabinet",
    "configcomponentname": NoCornerPlaceholder,
    "widthMin": epsilon,
    "widthMax": 20,
    "side":"NA",
    "cornerside": "R",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0          
  },     
  
  // door panels
  {
    "cabtype":"wall_cabinet",
    "configname": "Panel For Wall F",
    "configid":"PanelForWallF",
    "configcomponentname": PanelForWallF,
    "widthMin": 0.75,
    "widthMax": 0.75,
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0 ,
    "showInTable": false,      
  },      
  {
    "cabtype":"base_cabinet",
    "configname": "Base Door Panel",
    "configid":"BaseDoorPanel",
    "configcomponentname": BaseWallTallDoorPanel,
    "widthMin": 0.75,
    "widthMax": 0.75,
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0       
  },    
  {
    "cabtype":"wall_cabinet",
    "configname": "Wall Door Panel",
    "configid":"WallDoorPanel",
    "configcomponentname": BaseWallTallDoorPanel,
    "widthMin": 0.75,
    "widthMax": 0.75,
    "side":"NA",   
    //"allowedHeights": [36, 38, 40],
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  }, 
  {
    "cabtype":"tall_cabinet",
    "configname": "Tall Door Panel",
    "configid":"TallDoorPanel",
    "configcomponentname": BaseWallTallDoorPanel,
    "widthMin": 0.75,
    "widthMax": 0.75,
    //"allowedHeights": [92, 94, 96],
    "side":"NA",   
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    
  // placeholders
  {
    "cabtype":"base_cabinet",
    "configname": "Blank Placeholder",
    // the name below is used when inserting a cabinet to skip collision check
    // if you change it here..
    // you have to change it there as well
    "configid":"B:placeholder", 
    "configcomponentname": Placeholder, 
    "allowedHeights": [4],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },   
  
  {
    "cabtype":"wall_cabinet",
    "configname": "Blank Placeholder",
    // the name below is used when inserting a cabinet to skip collision check
    // if you change it here..
    // you have to change it there as well
    "configid":"W:placeholder", 
    "configcomponentname": Placeholder, 
    "allowedHeights": [4],
    "side":"NA",
    "compDrawers": 0,
    "compRollouts": 0,
    "compShelves": 0,
    "compDoors": 0    
  },    
];

const ToolTipHoverComponent = (props) => {
  const [tooltipProp, setTooltipProp] = useState({
    text: '',
    visible: false,
    x: 0,
    y: 0
  });  

  const rect = props.rect;

  return (
    <>

    <Rect
      key={rect.id}
      width={rect.width}
      height={rect.height}
      adjustDimsPar={rect.adjustDimsPar}

      onMouseMove={(e) => {
        //e.target.setAttr("opacity", 1)
        e.target.getStage().container().style.cursor = 'pointer';
        const mousePos = e.target.getStage().getPointerPosition();
        
        //const shownWidth = Math.round(100*(rect.width>rect.height?rect.height/90:rect.width/3.768115))/100; //(cabinetwidth>cabinetHeight?90:(cabinetwidth*130/cabinetHeight));
        //const shownHeight = Math.round(100*(rect.height>rect.width?rect.width/130:rect.height/3.768115))/100; //(cabinetwidth<cabinetHeight?130:(cabinetHeight*90/cabinetwidth));

        if (rect.adjustDimsPar) { // we are rendering the preview
          /*
          setTooltipProp({
            fill: 'black',
            text: `${rect.cabinetConfig}\nW=${shownWidth}, H=${shownHeight}, D=${24}`,
            visible: true,
            x: mousePos.x - rect.x + 20, //mousePos.x - 90,
            y: mousePos.y - rect.y
          });    
          */
        }
        else {
          setTooltipProp({
            fill: 'black',
            text: `${rect.cabinetConfig}\nW=${Math.round(100*rect.width/inchtopointfactor)/100}, H=${Math.round(100*rect.height/inchtopointfactor)/100}, D=${24}`,
            //text: `${JSON.stringify(rect.adjustDimsPar)}`,
            visible: true,
            x: mousePos.x - rect.x + 20, //mousePos.x - 90,
            y: mousePos.y - rect.y
          });     
        }       
      }}                   
      onMouseLeave={(e) => {
        if (!rect.selected) {
          e.target.setAttr("opacity", normalopacity);                          
        }
        e.target.getStage().container().style.cursor = 'default';                      
        setTooltipProp(prev => ({ ...prev, visible: false }));
      }}        
    />

    <Group x={0} y={0}>
      <Rect
        visible={tooltipProp.visible}
        width={180}
        height={35}
        x={tooltipProp.x}
        y={tooltipProp.y}
        fill="black"
        stroke="blue"
        strokeWidth={1}
        opacity={1}
      />      
      <Text
        {...tooltipProp}
        fontFamily="Calibri"
        fontSize={14}
        padding={5}
        opacity={1}
        fill={"white"}
      />    
    </Group>

    </> 
  );
};

const CommonRect = (props) => {
  let rect = props.rect;
  let adjustedHeight = rect.adjustedHeight?rect.adjustedHeight:rect.height;
  let coverHeight = 1.5*inchtopointfactor;

  return (
    <>    
    <Group
      height={rect.height}
      width={rect.width}
    >  
    <Rect

      onMouseEnter={(e) => rect.handleMouseEnter(e, rect)}
      onMouseMove={rect.handleMouseMove}
      onMouseLeave={rect.handleMouseLeave}

      zIndex={0}
      key={rect.id}
      width={rect.width}
      /*height={rect.height}*/
      height={adjustedHeight + 0}
      
      stroke={rect.stroke?rect.stroke:"black"}
      strokeWidth={1}                       
      opacity={rect.selected?1:normalopacity}                     
      fill={(rect.showInTable===undefined || rect.showInTable===true)?rect.fill:"white"}

      cabinettype={rect.cabinettype}
      shapename={rect.shapename}                        
      selected={rect.selected}

      cabinetConfig={rect.cabinetConfig}
      compDrawers={rect.compRollouts}
      compRollouts={rect.compRollouts}

      /*
      onMouseMove={(e) => {
        e.target.setAttr("opacity", 1)
        e.target.getStage().container().style.cursor = 'pointer';

        const mousePos = e.target.getStage().getPointerPosition();
        //console.log(layerPos);
        setTooltipProp({
          fill: 'black',
          text: `${rect.cabinetConfig}\nW=${rect.width/inchtopointfactor}, H=${rect.height/inchtopointfactor}, D=${24}`,
          visible: true,
          x: mousePos.x - rect.x + 20, //mousePos.x - 90,
          y: mousePos.y - rect.y
        });        
      }}                   
      onMouseLeave={(e) => {
        if (!rect.selected) {
          e.target.setAttr("opacity", normalopacity);                          
        }
        e.target.getStage().container().style.cursor = 'default';                      
        setTooltipProp(prev => ({ ...prev, visible: false }));
      }}  
      */      
                 
    />
    {/** Toe kick */}
    
    {((rect.cabinettype==="base_cabinet" || rect.cabinettype==="tall_cabinet") && 
    (!rect.cabinetConfig.toLowerCase().includes("filler")) &&
    (!rect.cabinetConfig.toLowerCase().includes("placeholder")) &&
    (rect.width > 12)) &&
    <>
    <Rect
      width={5}
      height={4*inchtopointfactor}
      x={10}
      y={adjustedHeight}
      fill={rect.fill}
      stroke={rect.stroke?rect.stroke:"black"}
      strokeWidth={1}               
      opacity={rect.selected?1:normalopacity}                     
    />
    <Rect
      width={5}
      height={4*inchtopointfactor}
      x={rect.width - 15}
      y={adjustedHeight}
      fill={rect.fill}
      stroke={rect.stroke?rect.stroke:"black"}
      strokeWidth={1}                     
      opacity={rect.selected?1:normalopacity}                     
    />
    </>        
    }
    

    {/*cabinet tooltip*/}
    {/**
    <Group x={0} y={0}>
      <Rect
        visible={tooltipProp.visible}
        width={140}
        height={35}
        x={tooltipProp.x}
        y={tooltipProp.y}
        fill="lightblue"
        stroke="blue"
        strokeWidth={1}
        opacity={1}
      />      
      <Text
        {...tooltipProp}
        fontFamily="Calibri"
        fontSize={14}
        padding={5}
        opacity={0.75}
      /> 

    </Group>
    */}

    {/**
    {(rect.width/inchtopointfactor >= 9 && !rect.cabinetConfig.includes("placeholder") && !rect.hideTexts) &&
    <Text text={rect.cabinetConfig} align="center" width={rect.width} y={rect.height/4} x={0}/> 
    }
    */}
    
    {(rect.width/inchtopointfactor >= 12 && !rect.cabinetConfig.includes("placeholder") && !rect.hideTexts) &&
    <>    
    <Text fill={"black"} text={"W=" + rect.width/inchtopointfactor + " in"} align="center" width={rect.width} y={0+3} x={0}/> 
    <Text fill={"black"} text={"H=" + rect.height/inchtopointfactor + " in"} align="left" width={rect.width} y={0+(adjustedHeight)*0.75} x={0+5}/> 
    {/*<Text text={rect.shapename} align="center" width={rect.width} y={0+(rect.height)-15  } x={0}/>     */}
    </>
    }

    {/**the indication of the side of the door */}
    {/*left */}
    {(rect.side === "L") &&
    <>
    <Line
      points={[0, 0, rect.width, -adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}
    />                    
    <Line
      points={[0, 0, rect.width, adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}/>  
    </>          
    }
    {/*right */}
    {(rect.side === "R") &&
    <>
    <Line
      points={[rect.width, 0, 0, -adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}
    />                    
    <Line
      points={[rect.width, 0, 0, adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}/>  
    </>          
    }  

    {(rect.side === "LR") &&
    <>
    <Line
      points={[0, 0, rect.width/2, -adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}/>                    
    <Line
      points={[0, 0, rect.width/2, adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}/>  


    <Line
      points={[rect.width, 0, rect.width/2, -adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}/>                    
    <Line
      points={[rect.width, 0, rect.width/2, adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      dash={[5, 5]}
      y={0+(adjustedHeight)/2}/>  
    

    <Line
      points={[rect.width/2, -adjustedHeight/2, rect.width/2, adjustedHeight/2]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}/>  
       
    </>
    }
    </Group>           
    {((rect.cabinettype === "base_cabinet" && !rect.cabinetConfig.toLowerCase().includes("placeholder")) || (rect.cabinetConfig === ":dishWasherElement") ) &&
    <Rect 
      x={0}
      y={0}
      height={-coverHeight}
      width={rect.width}
      fill={"gray"}
      stroke={"gray"}
    />    
    }          
    </>
  );
};

const OneShelf = (props) => {
  const rect = props.rect;
  let adjustedHeight = rect.adjustedHeight?rect.adjustedHeight:rect.height;

  return (
    <>
    {/*the shelf created with two lines*/}
    <Line 
      dash={[5, 5]}
      points={[0, 0, rect.width, 0]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}    
    />
    <Line 
      dash={[5, 5]}    
      points={[0, -5, rect.width, -5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}    
    />       
    </>  
  );  
};

const TwoShelves = (props) => {
  const rect = props.rect;
  let adjustedHeight = rect.adjustedHeight?rect.adjustedHeight:rect.height;

  return (
    <>
    <Line 
      dash={[5, 5]}
      points={[0, -adjustedHeight/6, rect.width, -adjustedHeight/6]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}    
    />
    <Line 
      dash={[5, 5]}    
      points={[0, -adjustedHeight/6-5, rect.width, -adjustedHeight/6-5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}    
    />    
    <Line 
      dash={[5, 5]}    
      points={[0, adjustedHeight/6, rect.width, adjustedHeight/6]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}    
    />
    <Line 
      dash={[5, 5]}    
      points={[0, adjustedHeight/6-5, rect.width, adjustedHeight/6-5]}
      stroke="black"
      strokeWidth={1}
      lineJoin="round"
      y={0+(adjustedHeight)/2}    
    />        
    </>  
  );  
};


const TwoRollOuts = (props) => {
  const rect = props.rect;
  let adjustedHeight = rect.adjustedHeight?rect.adjustedHeight:rect.height;

  return (
    <>
    {/*the roll outs created with two rects*/}
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={5}
      y={adjustedHeight/2-25}
      width={rect.width-10}
      height={25}
    />
    <Rect 
      stroke="black"
      strokeWidth={1}
      x={5}
      y={adjustedHeight-25-5}
      width={rect.width-10}
      height={25} 
    />         
    </>  
  );  
};

export { AllCabinetConfigs };




  /*
  const rect = props.rect;
  const normalopacity = globalnormalopacity;
  const internalpaddingfactor = 0.90;
  var padding = 10;
  return (
    <>
    <Rect 
      key={rect.id}
      width={rect.width}
      height={rect.height}
      
      stroke="black"
      strokeWidth={1}                       
      opacity={rect.selected?1:normalopacity}                     
      fill={rect.fill}

      cabinettype={rect.cabinettype}
      shapename={rect.shapename} 
    
    />

    <Rect
      x={padding}
      y={padding}
      width={rect.width-2*padding}
      height={rect.height-2*padding}
      
      stroke="black"
      strokeWidth={1}                       
      fill={rect.fill}
    />

    {props.numdoors === 1 && 
    <Rect
      x={rect.width*internalpaddingfactor + (1-internalpaddingfactor)*rect.width/2-15}
      y={(internalpaddingfactor)*rect.height/2}
      width={10}
      height={20}
      cornerRadius={10} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />      
    }

    {props.numdoors === 2 && 
    <>
    <Rect
      x={rect.width*internalpaddingfactor + (1-internalpaddingfactor)*rect.width/2-15}
      y={(internalpaddingfactor)*rect.height/2}
      width={10}
      height={20}
      cornerRadius={10} // Applies 10px radius to all corners
      stroke="black"
      strokeWidth={1}  
    />   
    <Line 
      points={[rect.width/2, padding, rect.width/2, rect.height-padding]}
      stroke="black"
      strokeWidth={1}      
    />   
    </>
    }    
  
    </>
  );
  */
